import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineL } from '@sorare/core/src/atoms/typography';
import { CardImg } from '@sorare/core/src/components/card/CardImg';
import {
  FOOTBALL_PLAY,
  FOOTBALL_PLAY_PRO_ONBOARDING_COMPOSE,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { StarterPackOpeningDialog } from '@sorare/gameplay/src/components/rewards/StarterPackOpeningDialog';

const StyledContainer = styled(Container)`
  background: linear-gradient(to bottom, #2c2b70 0%, rgba(44, 43, 112, 0) 100%);
`;
const Wrapper = styled(Vertical)`
  height: var(--100vh);
  align-items: center;
  padding: var(--double-unit) 0;
  @media ${tabletAndAbove} {
    padding: var(--quadruple-unit) 0;
  }
`;

const ContentWrapper = styled(Vertical)`
  flex: 1;
`;

const OpenStarterPackPage = () => {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { currentUser } = useCurrentUserContext();
  return (
    <>
      <StyledContainer>
        <Wrapper center>
          <HeadlineL>
            <FormattedMessage
              id="OpenStarterPackLeaguePage.title"
              defaultMessage="Open your starter pack"
            />
          </HeadlineL>
          <BodyM>
            <FormattedMessage
              id="OpenStarterPackLeaguePage.subtitle"
              defaultMessage="Receive your first set of players to start building your club."
            />
          </BodyM>

          <ContentWrapper center>
            <ButtonBase
              onClick={() => {
                setDialogOpen(true);
              }}
            >
              <CardImg
                src="https://frontend-assets.sorare.com/card_packs/football/laliga-es-1.png"
                width={320}
                onClick={() => {}}
              />
            </ButtonBase>
          </ContentWrapper>
        </Wrapper>
      </StyledContainer>
      <StarterPackOpeningDialog
        open={dialogOpen}
        cardPackPictureUrl="https://frontend-assets.sorare.com/card_packs/football/laliga-es-1.png"
        onContinue={() => {
          if (!currentUser?.forcedIntoOnboarding) {
            // skip play page onboarding step (play highlight) if existing user
            navigate(FOOTBALL_PLAY_PRO_ONBOARDING_COMPOSE);
          } else {
            navigate(FOOTBALL_PLAY);
          }
        }}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};

export default OpenStarterPackPage;
